import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_11 = ({ eyeColours, skinColours }) => {
  const colour0 = '#573D39';
  const colour1 = '#F15743';
  const colour2 = '#FFFEF0';
  const colour3 = '#F6E7D0';
  const colour4 = eyeColours.shadow;
  const colour5 = '#DF5656';
  const colour6 = skinColours.shadow;

  return (
    <>
      <g>
        <g>
          <path
            fill={colour0}
            d="M313.6,389.2c-0.7,3.5-1.9,12.9-6.2,15.3l14-1.4C321.7,392.3,314.2,385.7,313.6,389.2z"
          />
          <g>
            <path
              fill={colour0}
              d="M321.5,395.8c-2.8-0.8-7-4-7.1-5c-0.1-1,9.2-9.5,9.2-9.5L321.5,395.8z"
            />
            <path
              fill={colour1}
              opacity={0.5}
              d="M373,401.3c3-0.6,7.6-3.4,7.9-4.5c0.2-1-7.1-10.1-7.1-10.1L373,401.3z"
            />
            <path
              fill={colour0}
              d="M375.5,396.6c0.6-16.7-12.3-31.8-27.5-32.4c-15.2-0.6-28,12.5-28.6,29.2c-0.6,16.7,10.9,24.8,26.1,25.4
				C360.7,419.5,374.9,413.3,375.5,396.6z"
            />
            <path
              fill={colour2}
              d="M372.2,392.3c0.5-14.4-10.4-25.8-24.5-25.5c-14.1,0.3-25.9,12.2-26.4,26.6c-0.5,14.4,10.5,23.3,24.6,23
				C359.9,416.1,371.6,406.7,372.2,392.3z"
            />
            <path
              fill={colour3}
              d="M347.4,413c-14.1,0.3-25.1-9.4-24.5-23.7c0.1-2.3,0.5-4.6,1.1-6.7c-1.6,3.3-2.5,7-2.7,10.8
				c-0.5,14.4,10.5,24,24.5,23.7c11.9-0.2,22.2-7.6,25.4-18.6C366.9,407.2,357.8,412.8,347.4,413z"
            />
            <path
              fill={colour4}
              d="M359.8,395.1c0.3-7.1-5.5-13.1-13-13.4c-7.4-0.3-13.7,5.3-14,12.4c-0.3,7.1,5.5,13.1,13,13.4
				C353.3,407.8,359.6,402.2,359.8,395.1z"
            />
            <path
              fill={colour5}
              opacity={0.5}
              d="M380.9,396.7c-5.9-14.8-15.5-29.4-30.9-29.9c-13.9-0.5-32,10.3-35,23.8C333.4,384.9,365.4,385.3,380.9,396.7
				z"
            />
            <path
              fill={colour6}
              d="M315.9,387.9c3.1-7,37.8-22.1,63.7,5.8c0,0-4.1-29.8-30-30.8C319.4,361.8,315.9,387.9,315.9,387.9z"
            />
            <path
              fill={colour6}
              d="M315.6,384.8c-0.9,3.5-1.2,5.8-1.2,5.8c3.3-7.3,39.4-23.1,66.4,6.1c0,0-0.2-1.9-0.7-4.9
				C355.6,367.7,324.8,377.1,315.6,384.8z"
            />
            <path
              fill={colour2}
              d="M362,396.4c0.1-2.6-1.6-4.8-3.9-4.9c-2.2-0.1-4.1,2-4.2,4.6c-0.1,2.6,1.6,4.8,3.9,4.9
				C360,401.1,361.9,399,362,396.4z"
            />
            <path
              fill={colour2}
              d="M354.5,387.6c-0.6-1.4-1.8-2.3-2.7-2c-0.9,0.3-1.2,1.7-0.6,3.1c0.6,1.4,1.8,2.3,2.7,2.1
				C354.8,390.4,355.1,389,354.5,387.6z"
            />
          </g>
          <path
            fill={colour0}
            d="M381.5,397.7c-3.7,0.2-13.5-15.9-34.1-16.8c-20.6-1-30.3,7.2-32.7,10.8c0,0-2.9-2.6,0.8-7.7
			c3.7-5.1,18.1-11.6,33.3-7.8c18,4.5,30.4,19.8,37.7,19.1L381.5,397.7z"
          />
          <path
            fill={colour6}
            d="M321,406.8c0,0,4.3,15.9,25.8,15.4c16.5-0.4,26.7-12.4,29.1-21c0,0-15.8,10.2-32.8,9.1
			C325.9,409.1,321,406.8,321,406.8z"
          />
          <path
            fill={colour0}
            d="M383.5,396.8c-10.8,4.3-18.5,20.6-43.8,17.3c-25.3-3.3-19.6-8.6-39.3-6.2c0,0,12.1-7.4,20.6-5
			c8.6,2.4,22.2,8.3,34.9,5.3C366.1,405.7,375.9,396.8,383.5,396.8z"
          />
          <path
            fill={colour0}
            d="M303,378c0,0,7.8,7.6,14.1,7.3l-2.7,2.1C314.5,387.5,306.1,385.7,303,378z"
          />
          <path
            fill={colour0}
            d="M308.7,373.4c0,0,5.6,9.3,11.9,10.6l-3.1,1.4C317.4,385.4,309.7,381.6,308.7,373.4z"
          />
          <path
            fill={colour0}
            d="M313.7,370.5c0,0,4.9,9.7,11,11.5l-3.2,1.2C321.5,383.2,314.1,378.7,313.7,370.5z"
          />
          <path
            fill={colour0}
            d="M320.5,368c0,0,4.1,10.1,10,12.4l-3.3,0.9C327.2,381.2,320.2,376.2,320.5,368z"
          />
          <path
            fill={colour0}
            d="M328.3,365.9c0,0,0.5,8.8,5.2,10.6l-3.3,0.9C330.2,377.4,325.4,373.2,328.3,365.9z"
          />
        </g>
        <g>
          <path
            fill={colour0}
            d="M485.2,389.2c0.7,3.5,1.9,12.9,6.2,15.3l-14-1.4C477.1,392.3,484.6,385.7,485.2,389.2z"
          />
          <g>
            <path
              fill={colour0}
              d="M477.3,395.8c2.8-0.8,7-4,7.1-5c0.1-1-9.2-9.5-9.2-9.5L477.3,395.8z"
            />
            <path
              fill={colour1}
              opacity={0.5}
              d="M425.8,401.3c-3-0.6-7.6-3.4-7.9-4.5c-0.2-1,7.1-10.1,7.1-10.1L425.8,401.3z"
            />
            <path
              fill={colour0}
              d="M423.3,396.6c-0.6-16.7,12.3-31.8,27.5-32.4c15.2-0.6,28,12.5,28.6,29.2c0.6,16.7-10.9,24.8-26.1,25.4
				C438.2,419.5,423.9,413.3,423.3,396.6z"
            />
            <path
              fill={colour2}
              d="M426.6,392.3c-0.5-14.4,10.4-25.8,24.5-25.5c14.1,0.3,25.9,12.2,26.4,26.6c0.5,14.4-10.5,23.3-24.6,23
				C438.9,416.1,427.2,406.7,426.6,392.3z"
            />
            <path
              fill={colour3}
              d="M451.4,413c14.1,0.3,25.1-9.4,24.5-23.7c-0.1-2.3-0.5-4.6-1.1-6.7c1.6,3.3,2.5,7,2.7,10.8
				c0.5,14.4-10.5,24-24.5,23.7c-11.9-0.2-22.2-7.6-25.4-18.6C431.9,407.2,441,412.8,451.4,413z"
            />
            <path
              fill={colour4}
              d="M439,395.1c-0.3-7.1,5.5-13.1,13-13.4c7.4-0.3,13.7,5.3,14,12.4c0.3,7.1-5.5,13.1-13,13.4
				C445.5,407.8,439.2,402.2,439,395.1z"
            />
            <path
              fill={colour5}
              opacity={0.5}
              d="M418,396.7c5.9-14.8,15.5-29.4,30.9-29.9c13.9-0.5,32,10.3,35,23.8C465.4,384.9,433.4,385.3,418,396.7z"
            />
            <path
              fill={colour6}
              d="M482.9,387.9c-3.1-7-37.8-22.1-63.7,5.8c0,0,4.1-29.8,30-30.8C479.4,361.8,482.9,387.9,482.9,387.9z"
            />
            <path
              fill={colour6}
              d="M483.2,384.8c0.9,3.5,1.2,5.8,1.2,5.8c-3.3-7.3-39.4-23.1-66.4,6.1c0,0,0.2-1.9,0.7-4.9
				C443.2,367.7,474.1,377.1,483.2,384.8z"
            />
            <path
              fill={colour2}
              d="M458.9,399.9c-0.1-2.6,1.6-4.8,3.9-4.9c2.2-0.1,4.1,2,4.2,4.6c0.1,2.6-1.6,4.8-3.9,4.9
				C460.9,404.5,459,402.5,458.9,399.9z"
            />
            <path
              fill={colour2}
              d="M457.5,390.3c-0.9-1.3-1-2.8-0.2-3.3c0.7-0.6,2-0.1,2.9,1.2c0.9,1.3,1,2.8,0.2,3.3
				C459.7,392.1,458.4,391.5,457.5,390.3z"
            />
          </g>
          <path
            fill={colour0}
            d="M417.3,397.7c3.7,0.2,13.5-15.9,34.1-16.8c20.6-1,30.3,7.2,32.7,10.8c0,0,2.9-2.6-0.8-7.7
			c-3.7-5.1-18.1-11.6-33.3-7.8c-18,4.5-30.4,19.8-37.7,19.1L417.3,397.7z"
          />
          <path
            fill={colour6}
            d="M477.9,406.8c0,0-4.3,15.9-25.8,15.4c-16.5-0.4-26.7-12.4-29.1-21c0,0,15.8,10.2,32.8,9.1
			C472.9,409.1,477.9,406.8,477.9,406.8z"
          />
          <path
            fill={colour0}
            d="M415.3,396.8c10.8,4.3,18.5,20.6,43.8,17.3c25.3-3.3,19.6-8.6,39.3-6.2c0,0-12.1-7.4-20.6-5
			c-8.6,2.4-22.2,8.3-34.9,5.3C432.7,405.7,423,396.8,415.3,396.8z"
          />
          <path
            fill={colour0}
            d="M495.8,378.1c0,0-7.8,7.6-14.1,7.3l2.7,2.1C484.3,387.5,492.8,385.7,495.8,378.1z"
          />
          <path
            fill={colour0}
            d="M490.2,373.4c0,0-5.6,9.3-11.9,10.6l3.1,1.4C481.4,385.4,489.1,381.6,490.2,373.4z"
          />
          <path
            fill={colour0}
            d="M485.1,370.5c0,0-4.9,9.7-11,11.5l3.2,1.2C477.3,383.2,484.7,378.7,485.1,370.5z"
          />
          <path
            fill={colour0}
            d="M478.3,368c0,0-4.1,10.1-10,12.4l3.3,0.9C471.6,381.2,478.6,376.2,478.3,368z"
          />
          <path
            fill={colour0}
            d="M470.5,365.9c0,0-0.5,8.8-5.2,10.6l3.3,0.9C468.6,377.4,473.4,373.2,470.5,365.9z"
          />
        </g>
      </g>
    </>
  );
};

export default Eyes_11;
